import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { FunctionNode } from '../../types';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';

export const FunctionNodeView = memo(function FunctionNodeView({ data }: NodeProps<FunctionNode>) {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <CardShell
      kind="function"
      accent="teal"
      title={getNodeDisplayLabel('function', displayLanguage)}
      summary={data.functionName || (displayLanguage === 'en' ? 'Unnamed' : '名前なし')}
    >
      <Handle type="target" position={Position.Left} className="!bg-teal-500" />
      <Handle type="source" position={Position.Right} className="!bg-teal-500" />
    </CardShell>
  );
});